import type { ArmyPaint } from "../../../lib/core/ArmyPainter/ArmyPaint.type"
import { colorNamesPool, type ColorNamePair } from "../../../lib/core/player/colorNamesPool"
import randomElement from "../../../lib/core/rng/randomElement"
import tmpRngWith from "../../../lib/core/rng/tmpRngWith"
import type { ArmyPaintId } from "../../../lib/core/ArmyPainter/ArmyPaintId.type"
import { StateMapDisk } from "../../../lib/core/state/state_map_disk.enum"

export default function createRandomArmyPaint(id: ArmyPaintId): ArmyPaint {

  const colorNamePair : ColorNamePair = randomElement(colorNamesPool, tmpRngWith(id))

  return {
    id,
    user_id: null,
    disk: StateMapDisk.IndexedDB,
    ...colorNamePair,
    dname: null,
  }
}
